import { render, staticRenderFns } from "./DataSetsLanding.vue?vue&type=template&id=1efc1582&scoped=true"
import script from "./DataSetsLanding.vue?vue&type=script&lang=js"
export * from "./DataSetsLanding.vue?vue&type=script&lang=js"
import style0 from "./DataSetsLanding.vue?vue&type=style&index=0&id=1efc1582&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efc1582",
  null
  
)

export default component.exports